// extracted by mini-css-extract-plugin
export var arrow = "LanguageDropdown-module--arrow--3c17b";
export var arrowNo = "LanguageDropdown-module--arrow_no--5aebf";
export var arrowYes = "LanguageDropdown-module--arrow_yes--c1d2b";
export var buttonContainer = "LanguageDropdown-module--buttonContainer--b4603";
export var checkbox = "LanguageDropdown-module--checkbox--79b08";
export var dropdownItemLabel = "LanguageDropdown-module--dropdownItemLabel--b0be3";
export var flex = "LanguageDropdown-module--flex--51334";
export var flex1 = "LanguageDropdown-module--flex_1--c9b66";
export var flexCenter = "LanguageDropdown-module--flex_center--29cc8";
export var flexCenterCol = "LanguageDropdown-module--flex_center_col--85f2f";
export var flexCol = "LanguageDropdown-module--flex_col--fdca8";
export var flexFixCenterCol = "LanguageDropdown-module--flex_fix_center_col--ec175";
export var flexFixedCenterCol = "LanguageDropdown-module--flex_fixed_center_col--08ad7";
export var languageDropdownContainer = "LanguageDropdown-module--languageDropdownContainer--c104f";
export var languageItemContainer = "LanguageDropdown-module--languageItemContainer--1062d";
export var languageItemsContainer = "LanguageDropdown-module--languageItemsContainer--6d8b1";
export var languageOptionName = "LanguageDropdown-module--languageOptionName--16012";
export var languageSelectDropdownContainer = "LanguageDropdown-module--languageSelectDropdownContainer--fc67b";
export var overlayTitle = "LanguageDropdown-module--overlayTitle--0a468";
export var rotating = "LanguageDropdown-module--rotating--cf6cb";
export var searchQueryButton = "LanguageDropdown-module--searchQueryButton--5daae";
export var selectedLanguageContainer = "LanguageDropdown-module--selectedLanguageContainer--bbb80";
export var selectedLanguageLabel = "LanguageDropdown-module--selectedLanguageLabel--38273";
export var selectedLanguageName = "LanguageDropdown-module--selectedLanguageName--27db9";